<template>
  <img v-if="logoSrc" :src="logoSrc" :alt="alt" :class="cssClass" />
</template>

<script>
const BRAND_LOGO_STORAGE_KEY = "vanguard.brandLogo";

export default {
  name: "Logo",
  props: {
    alt: {
      type: String,
      default: "",
    },
    cssClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      logoSrc: null,
    };
  },
  mounted() {
    if (window.globalConfig?.hideBrandLogo === true) {
      this.logoSrc = null;
      return;
    }
    const configLogo = window.globalConfig?.logo;
    if (configLogo) {
      this.logoSrc = configLogo;
      this.persistLogo(configLogo);
    } else {
      this.logoSrc = this.readPersistedLogo();
    }
  },
  methods: {
    persistLogo(url) {
      try {
        window.sessionStorage?.setItem(BRAND_LOGO_STORAGE_KEY, url);
      } catch (e) {
        // sessionStorage indisponible (mode privé Safari, iframe sandbox, etc.)
      }
    },
    readPersistedLogo() {
      try {
        return window.sessionStorage?.getItem(BRAND_LOGO_STORAGE_KEY) || null;
      } catch (e) {
        return null;
      }
    },
  },
};
</script>
